import _ from 'lodash'

import { checkRule } from './rule-mapper'
import values from 'core/data-model/constants/values'

export const checkRules = (rider, eligibilities, validationType) => {
  const checkRuleEligibility = (rule) => checkRule(rule, eligibilities)
  const isApplicable = (rule) => {
    return !validationType || rule.validationType === validationType
  }

  const messages = _.chain(rider.rules)
    .filter(isApplicable)
    .map(checkRuleEligibility)
    .filter((error) => error && error.message)
    .value()

  const isOk = _.every(messages, (error) => {
    return error.type === values.ADDITIONAL_INFORMATION
  })

  return {
    isOk,
    messages,
  }
}
